/**
 * Installation Badge Component
 *
 * Spanner marker shown on products that carry installation time.
 *
 * The label is deliberately the same on every product: installation is costed into the
 * price, and the hours and the labour charge behind that figure are ours to work out,
 * not something the customer has to reconcile.
 *
 * @package
 */

import PropTypes from 'prop-types';
import { __ } from '@wordpress/i18n';
import Icon from './Icon';

const InstallationBadge = ( { hours } ) => {
	if ( ! hours || hours <= 0 ) {
		return null;
	}

	const label = __( 'Installation is included in the price', 'at-vehicle-configurator' );

	return (
		<span className="configurator-installation-badge" data-tooltip={ label }>
			<Icon name="spanner" size="small" className="configurator-installation-badge-icon" />
			<span className="screen-reader-text">{ label }</span>
		</span>
	);
};

InstallationBadge.propTypes = {
	hours: PropTypes.number,
};

InstallationBadge.defaultProps = {
	hours: 0,
};

export default InstallationBadge;
